// Auto-generated by generate-build-info.js - DO NOT EDIT
export const BUILD_INFO = {
  version: '0.1.283',
  buildTimestamp: '2026-06-05T13:40:27.968Z',
  buildDate: '05 Jun 2026, 14:40 BST',
  gitCommit: '8156b2d9a',
  gitBranch: 'feature/consumer-slice-08b-welcome-token-grants',
  gitDirty: true,
  worktreeHash: '014731c28407529b',
  worktreeStatusLineCount: 56,
  buildNumber: 1780666827981
} as const;
